export default __webpack_public_path__ + "static/media/section2-bg.343c9c6d.png";